<template>
    <div class="w-full  rounded overflow-hidden shadow-lg mx-auto bg-white pb-4">
    
    <SiteHeader /> 
    <RouterView />
    <Snackbar />
    
    <div class="text-gray-200 text-sm ml-auto text-center mt-4">
      &copy; ReservePro version: {{ version }}
    </div>
    </div>
</template>

<script setup>
import { RouterView } from 'vue-router';
import SiteHeader from '@/components/SiteHeader.vue';
import Snackbar from '@/components/Snackbar.vue';
const version = __APP_VERSION__;
</script>

